import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"

// Initialize Stimulus application
const application = Application.start()

// Import and register controllers
import DropdownController from "./controllers/dropdown_controller"
application.register("dropdown", DropdownController)

import VoiceoverStatusController from "./controllers/voiceover_status_controller"
application.register("voiceover-status", VoiceoverStatusController)

import NarrationGeneratorController from "./controllers/narration_generator_controller"
application.register("narration-generator", NarrationGeneratorController)

import TopicIdeationController from "./controllers/topic_ideation_controller"
application.register("topic-ideation", TopicIdeationController)

import SketchObjectStatusController from "./controllers/sketch_object_status_controller"
application.register("sketch-object-status", SketchObjectStatusController)

import PresenterPickerController from "./controllers/presenter_picker_controller"
application.register("presenter-picker", PresenterPickerController)

import PresenterUploadController from "./controllers/presenter_upload_controller"
application.register("presenter-upload", PresenterUploadController)

import PresenterReviewController from "./controllers/presenter_review_controller"
application.register("presenter-review", PresenterReviewController)

import BrandingPreviewController from "./controllers/branding_preview_controller"
application.register("branding-preview", BrandingPreviewController)

import SlideshowEditorController from "./controllers/slideshow_editor_controller"
application.register("slideshow-editor", SlideshowEditorController)

import TimelineScrollController from "./controllers/timeline_scroll_controller"
application.register("timeline-scroll", TimelineScrollController)

import FocalPointController from "./controllers/focal_point_controller"
application.register("focal-point", FocalPointController)

import KenBurnsEditorController from "./controllers/ken_burns_editor_controller"
application.register("ken-burns-editor", KenBurnsEditorController)

import TabsController from "./controllers/tabs_controller"
application.register("tabs", TabsController)

import StoryScriptTabsController from "./controllers/story_script_tabs_controller"
application.register("story-script-tabs", StoryScriptTabsController)

import VoicePreviewController from "./controllers/voice_preview_controller"
application.register("voice-preview", VoicePreviewController)

import CopyToClipboardController from "./controllers/copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import SegmentSettingsController from "./controllers/segment_settings_controller"
application.register("segment-settings", SegmentSettingsController)

import MediaImportController from "./controllers/media_import_controller"
application.register("media-import", MediaImportController)

import MovePickerController from "./controllers/move_picker_controller"
application.register("move-picker", MovePickerController)

import SortableListController from "./controllers/sortable_list_controller"
application.register("sortable-list", SortableListController)

import ModalController from "./controllers/modal_controller"
application.register("modal", ModalController)

import SegmentSortableController from "./controllers/segment_sortable_controller"
application.register("segment-sortable", SegmentSortableController)

import FillerSortableController from "./controllers/filler_sortable_controller"
application.register("filler-sortable", FillerSortableController)

import KenBurnsPreviewController from "./controllers/ken_burns_preview_controller"
application.register("ken-burns-preview", KenBurnsPreviewController)

import MediaReplaceController from "./controllers/media_replace_controller"
application.register("media-replace", MediaReplaceController)

import FontPreviewController from "./controllers/font_preview_controller"
application.register("font-preview", FontPreviewController)

import DialogueEditorController from "./controllers/dialogue_editor_controller"
application.register("dialogue-editor", DialogueEditorController)

import VideoEditorController from "./controllers/video_editor_controller"
application.register("video-editor", VideoEditorController)

import ClipPreviewController from "./controllers/clip_preview_controller"
application.register("clip-preview", ClipPreviewController)

import CollapsibleController from "./controllers/collapsible_controller"
application.register("collapsible", CollapsibleController)

import ColorPickerController from "./controllers/color_picker_controller"
application.register("color-picker", ColorPickerController)

import TextPathEditorController from "./controllers/text_path_editor_controller"
application.register("text-path-editor", TextPathEditorController)

import TtsGeneratorController from "./controllers/tts_generator_controller"
application.register("tts-generator", TtsGeneratorController)

import AudioPreviewController from "./controllers/audio_preview_controller"
application.register("audio-preview", AudioPreviewController)

import ClipAudioPreviewController from "./controllers/clip_audio_preview_controller"
application.register("clip-audio-preview", ClipAudioPreviewController)

import AudioHookPickerController from "./controllers/audio_hook_picker_controller"
application.register("audio-hook-picker", AudioHookPickerController)

import AudioTagPaletteController from "./controllers/audio_tag_palette_controller"
application.register("audio-tag-palette", AudioTagPaletteController)

import DialogueScriptController from "./controllers/dialogue_script_controller"
application.register("dialogue-script", DialogueScriptController)

import ShortsWizardController from "./controllers/shorts_wizard_controller"
application.register("shorts-wizard", ShortsWizardController)

import ScriptEditorController from "./controllers/script_editor_controller"
application.register("script-editor", ScriptEditorController)

import GenerationProgressController from "./controllers/generation_progress_controller"
application.register("generation-progress", GenerationProgressController)

import ReferenceImagesController from "./controllers/reference_images_controller"
application.register("reference-images", ReferenceImagesController)

import ScriptEnhancerController from "./controllers/script_enhancer_controller"
application.register("script-enhancer", ScriptEnhancerController)

import VoiceSelectorController from "./controllers/voice_selector_controller"
application.register("voice-selector", VoiceSelectorController)

import SoundPreviewController from "./controllers/sound_preview_controller"
application.register("sound-preview", SoundPreviewController)

import TemplateDesignerController from "./controllers/template_designer_controller"
application.register("template-designer", TemplateDesignerController)

import MobileNavController from "./controllers/mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import VideoLabFormController from "./controllers/video_lab_form_controller"
application.register("video-lab-form", VideoLabFormController)

import QuizEditorController from "./controllers/quiz_editor_controller"
application.register("quiz-editor", QuizEditorController)

import ListicleEditorController from "./controllers/listicle_editor_controller"
application.register("listicle-editor", ListicleEditorController)

import DataRevealEditorController from "./controllers/data_reveal_editor_controller"
application.register("data-reveal-editor", DataRevealEditorController)

import ComposeEditorController from "./controllers/compose_editor_controller"
application.register("compose-editor", ComposeEditorController)

import ComposeTimelineController from "./controllers/compose_timeline_controller"
application.register("compose-timeline", ComposeTimelineController)

import ComposePaletteController from "./controllers/compose_palette_controller"
application.register("compose-palette", ComposePaletteController)

import ComposeInsertController from "./controllers/compose_insert_controller"
application.register("compose-insert", ComposeInsertController)

import ComposePreviewController from "./controllers/compose_preview_controller"
application.register("compose-preview", ComposePreviewController)

import NestedFieldsController from "./controllers/nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import BackgroundTypeController from "./controllers/background_type_controller"
application.register("background-type", BackgroundTypeController)

import ScriptedVideoEditorController from "./controllers/scripted_video/editor_controller"
application.register("scripted-video--editor", ScriptedVideoEditorController)

import ScriptedVideoScriptController from "./controllers/scripted_video/script_controller"
application.register("scripted-video--script", ScriptedVideoScriptController)

import ScriptedVideoScenesController from "./controllers/scripted_video/scenes_controller"
application.register("scripted-video--scenes", ScriptedVideoScenesController)

import ScriptedVideoReferencesController from "./controllers/scripted_video/references_controller"
application.register("scripted-video--references", ScriptedVideoReferencesController)

import ScriptedVideoRatingController from "./controllers/scripted_video/rating_controller"
application.register("scripted-video--rating", ScriptedVideoRatingController)

import ScriptedVideoSceneGenerationController from "./controllers/scripted_video/scene_generation_controller"
application.register("scripted-video--scene-generation", ScriptedVideoSceneGenerationController)

import ScriptedVideoSceneSettingsController from "./controllers/scripted_video/scene_settings_controller"
application.register("scripted-video--scene-settings", ScriptedVideoSceneSettingsController)

import ScriptedVideoExtendController from "./controllers/scripted_video/extend_controller"
application.register("scripted-video--extend", ScriptedVideoExtendController)

import ScriptedVideoNarrationSegmentsController from "./controllers/scripted_video/narration_segments_controller"
application.register("scripted-video--narration-segments", ScriptedVideoNarrationSegmentsController)

import ScriptedVideoSceneDetailController from "./controllers/scripted_video/scene_detail_controller"
application.register("scripted-video--scene-detail", ScriptedVideoSceneDetailController)

import ScriptedVideoShotListController from "./controllers/scripted_video/shot_list_controller"
application.register("scripted-video--shot-list", ScriptedVideoShotListController)

import ScriptedVideoShotSortableController from "./controllers/scripted_video/shot_sortable_controller"
application.register("scripted-video--shot-sortable", ScriptedVideoShotSortableController)

import ScriptedVideoFirstFrameController from "./controllers/scripted_video/first_frame_controller"
application.register("scripted-video--first-frame", ScriptedVideoFirstFrameController)

import ScriptedVideoAudioController from "./controllers/scripted_video/audio_controller"
application.register("scripted-video--audio", ScriptedVideoAudioController)

import ScriptedVideoAssemblyController from "./controllers/scripted_video/assembly_controller"
application.register("scripted-video--assembly", ScriptedVideoAssemblyController)

import TextOverlayEditorController from "./controllers/text_overlay_editor_controller"
application.register("text-overlay-editor", TextOverlayEditorController)

import BatchProgressController from "./controllers/batch_progress_controller"
application.register("batch-progress", BatchProgressController)

import BatchReviewController from "./controllers/batch_review_controller"
application.register("batch-review", BatchReviewController)

import BatchPromptInputController from "./controllers/batch_prompt_input_controller"
application.register("batch-prompt-input", BatchPromptInputController)

import ChannelPlatformController from "./controllers/channel_platform_controller"
application.register("channel-platform", ChannelPlatformController)

import TopicGeneratorController from "./controllers/topic_generator_controller"
application.register("topic-generator", TopicGeneratorController)

import AiVideoClipController from "./controllers/ai_video_clip_controller"
application.register("ai-video-clip", AiVideoClipController)

import SegmentVideoController from "./controllers/segment_video_controller"
application.register("segment-video", SegmentVideoController)

import VideoPreviewController from "./controllers/video_preview_controller"
application.register("video-preview", VideoPreviewController)

import ToggleController from "./controllers/toggle_controller"
application.register("toggle", ToggleController)

import SegmentImageRegenController from "./controllers/segment_image_regen_controller"
application.register("segment-image-regen", SegmentImageRegenController)

import AnchorRegenController from "./controllers/anchor_regen_controller"
application.register("anchor-regen", AnchorRegenController)

import ClipBuilderController from "./controllers/clip_builder_controller"
application.register("clip-builder", ClipBuilderController)

import ClipVideoSourceController from "./controllers/clip_video_source_controller"
application.register("clip-video-source", ClipVideoSourceController)

import ClipOverlaysController from "./controllers/clip_overlays_controller"
application.register("clip-overlays", ClipOverlaysController)

import ClipMasterTracksController from "./controllers/clip_master_tracks_controller"
application.register("clip-master-tracks", ClipMasterTracksController)

import BeatSyncedSceneController from "./controllers/beat_synced_scene_controller"
application.register("beat-synced-scene", BeatSyncedSceneController)

import BeatSyncedBuilderController from "./controllers/beat_synced_builder_controller"
application.register("beat-synced-builder", BeatSyncedBuilderController)

import ClipListController from "./controllers/clip_list_controller"
application.register("clip-list", ClipListController)

import CarouselEditorController from "./controllers/carousel_editor_controller"
application.register("carousel-editor", CarouselEditorController)

import PolygonRegionController from "./controllers/polygon_region_controller"
application.register("polygon-region", PolygonRegionController)

import ClickSegmentController from "./controllers/click_segment_controller"
application.register("click-segment", ClickSegmentController)

import MusicVideoUpdatesController from "./controllers/music_video_updates_controller"
application.register("music-video-updates", MusicVideoUpdatesController)

import ScrollPreserveController from "./controllers/scroll_preserve_controller"
application.register("scroll-preserve", ScrollPreserveController)

import VariantCollapseController from "./controllers/variant_collapse_controller"
application.register("variant-collapse", VariantCollapseController)

import NicheBrowseController from "./controllers/niche_browse_controller"
application.register("niche-browse", NicheBrowseController)

import VocabularyWizardController from "./controllers/vocabulary_wizard_controller"
application.register("vocabulary-wizard", VocabularyWizardController)

import VocabularyGenerationController from "./controllers/vocabulary_generation_controller"
application.register("vocabulary-generation", VocabularyGenerationController)

import VocabularySetWizardController from "./controllers/vocabulary_set_wizard_controller"
application.register("vocabulary-set-wizard", VocabularySetWizardController)

import VocabularySetGenerationController from "./controllers/vocabulary_set_generation_controller"
application.register("vocabulary-set-generation", VocabularySetGenerationController)

import IllustratedCarouselWizardController from "./controllers/illustrated_carousel_wizard_controller"
application.register("illustrated-carousel-wizard", IllustratedCarouselWizardController)

import IllustratedCarouselGenerationController from "./controllers/illustrated_carousel_generation_controller"
application.register("illustrated-carousel-generation", IllustratedCarouselGenerationController)

import RemotionPreviewController from "./controllers/remotion_preview_controller"
application.register("remotion-preview", RemotionPreviewController)

import SeqEntryController from "./controllers/seq_entry_controller"
application.register("seq-entry", SeqEntryController)

import SeqListController from "./controllers/seq_list_controller"
application.register("seq-list", SeqListController)

import PaletteLivePreviewController from "./controllers/palette_live_preview_controller"
application.register("palette-live-preview", PaletteLivePreviewController)

import SubjectPreviewController from "./controllers/subject_preview_controller"
application.register("subject-preview", SubjectPreviewController)

import SpeakingClipPickerController from "./controllers/speaking_clip_picker_controller"
application.register("speaking-clip-picker", SpeakingClipPickerController)

import BeatSequenceEditorController from "./controllers/beat_sequence_editor_controller"
application.register("beat-sequence-editor", BeatSequenceEditorController)

import StylePresetsController from "./controllers/style_presets_controller"
application.register("style-presets", StylePresetsController)










import BbHoldDisplayController from "./controllers/bb_hold_display_controller"
application.register("bb-hold-display", BbHoldDisplayController)

import LoopPreviewController from "./controllers/loop_preview_controller"
application.register("loop-preview", LoopPreviewController)


import QuizShortLivePreviewController from "./controllers/quiz_short_live_preview_controller"
application.register("quiz-short-live-preview", QuizShortLivePreviewController)

import PatternUnlockLivePreviewController from "./controllers/pattern_unlock_live_preview_controller"
application.register("pattern-unlock-live-preview", PatternUnlockLivePreviewController)

import BackchainBuilderLivePreviewController from "./controllers/backchain_builder_live_preview_controller"
application.register("backchain-builder-live-preview", BackchainBuilderLivePreviewController)

import MinimalPairLivePreviewController from "./controllers/minimal_pair_live_preview_controller"
application.register("minimal-pair-live-preview", MinimalPairLivePreviewController)

import FalseFriendLivePreviewController from "./controllers/false_friend_live_preview_controller"
application.register("false-friend-live-preview", FalseFriendLivePreviewController)

import SubstitutionDrillLivePreviewController from "./controllers/substitution_drill_live_preview_controller"
application.register("substitution-drill-live-preview", SubstitutionDrillLivePreviewController)

import ClozePassageLivePreviewController from "./controllers/cloze_passage_live_preview_controller"
application.register("cloze-passage-live-preview", ClozePassageLivePreviewController)

import CollocationLivePreviewController from "./controllers/collocation_live_preview_controller"
application.register("collocation-live-preview", CollocationLivePreviewController)

import DictationLivePreviewController from "./controllers/dictation_live_preview_controller"
application.register("dictation-live-preview", DictationLivePreviewController)

import BgPickerSearchController from "./controllers/bg_picker_search_controller"
application.register("bg-picker-search", BgPickerSearchController)

import SubjectPickerSearchController from "./controllers/subject_picker_search_controller"
application.register("subject-picker-search", SubjectPickerSearchController)

import BackgroundFilterController from "./controllers/background_filter_controller"
application.register("background-filter", BackgroundFilterController)

// taught_* wizards migrated from static HTML-mock previews to the real
// composition via Common::RemotionPreviewPanelComponent (the generic
// `remotion-preview` controller). Their per-template *-live-preview
// controllers were retired with the mock panels.

import StrokeTokensController from "./controllers/stroke_tokens_controller"
application.register("stroke-tokens", StrokeTokensController)

import BrandKitRestoreController from "./controllers/brand_kit_restore_controller"
application.register("brand-kit-restore", BrandKitRestoreController)

import StyleAuditController from "./controllers/style_audit_controller"
application.register("style-audit", StyleAuditController)

import RenderPreviewClipController from "./controllers/render_preview_clip_controller"
application.register("render-preview-clip", RenderPreviewClipController)

import AudioMixTrackSortableController from "./controllers/audio_mix_track_sortable_controller"
application.register("audio-mix-track-sortable", AudioMixTrackSortableController)

import AudioMixRenameController from "./controllers/audio_mix_rename_controller"
application.register("audio-mix-rename", AudioMixRenameController)

import AssetSourceController from "./controllers/asset_source_controller"
application.register("asset-source", AssetSourceController)

import LinkedSelectController from "./controllers/linked_select_controller"
application.register("linked-select", LinkedSelectController)

import StyleSectionsController from "./controllers/style_sections_controller"
application.register("style-sections", StyleSectionsController)

import ConditionalFieldsController from "./controllers/conditional_fields_controller"
application.register("conditional-fields", ConditionalFieldsController)

import TextEffectOptionsController from "./controllers/text_effect_options_controller"
application.register("text-effect-options", TextEffectOptionsController)

import MusicPromoPreviewController from "./controllers/music_promo_preview_controller"
application.register("music-promo-preview", MusicPromoPreviewController)

import MusicTheoryPreviewController from "./controllers/music_theory_preview_controller"
application.register("music-theory-preview", MusicTheoryPreviewController)

import MusicTheoryThemePresetController from "./controllers/music_theory_theme_preset_controller"
application.register("music-theory-theme-preset", MusicTheoryThemePresetController)

import MusicTheoryProgressionPresetController from "./controllers/music_theory_progression_preset_controller"
application.register("music-theory-progression-preset", MusicTheoryProgressionPresetController)

import MusicTheoryInstrumentSampleController from "./controllers/music_theory_instrument_sample_controller"
application.register("music-theory-instrument-sample", MusicTheoryInstrumentSampleController)

import MusicTheoryPresenterStepController from "./controllers/music_theory_presenter_step_controller"
application.register("music-theory-presenter-step", MusicTheoryPresenterStepController)

import ObjectPickerController from "./controllers/object_picker_controller"
application.register("object-picker", ObjectPickerController)

// AOE2 curation review editor (admin)
import Aoe2ClipReviewController from "./controllers/aoe2_clip_review_controller"
application.register("aoe2-clip-review", Aoe2ClipReviewController)

import Aoe2TrimController from "./controllers/aoe2_trim_controller"
application.register("aoe2-trim", Aoe2TrimController)

import Aoe2ReframeEditorController from "./controllers/aoe2_reframe_editor_controller"
application.register("aoe2-reframe-editor", Aoe2ReframeEditorController)

import Aoe2RenderStatusController from "./controllers/aoe2_render_status_controller"
application.register("aoe2-render-status", Aoe2RenderStatusController)

// YouTube analytics store: live collector state while a pass is in flight (admin)
import YtCollectorStatusController from "./controllers/yt_collector_status_controller"
application.register("yt-collector-status", YtCollectorStatusController)

import "./channels"
